import React from 'react'
import {Spin, Button, message} from 'antd'
import common from '@/public/common'
import './index.less'
import { ajaxApi} from '@/server'
import { summation, getParmUrl, outputMoney,getCookie,getCookieNew } from '../../public/utils'
import { get } from 'lodash'
const urlLink = common.scpUrl + 'change-stack'

class WithPrint extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      sping: false,
      data: {}
    }
  }
  componentDidMount () {
    this.setState({
      sping: true
    }, () => {
      this.getPrint()
    })
  }
    getPrint = () => {
      ajaxApi({
        url: urlLink + '/DeliveryPrint',
        params: {
          action: 'deliverydetailprint',
          data: { DeliveryID: getParmUrl('DeliveryID'),s_code:getCookieNew('supplier_code') ? getCookieNew('supplier_code'): null}
        }
      }).then(res => {
        console.log(111,res)
        if (res.data&&res.data.flag === true && res.data.data) {
          this.setState({
            sping: false,
            data: res.data.data
          })
        } else {
          message.error(res.data.error_message)
        }
      })
    }
    print = () => {
      window.document.body.innerHTML = window.document.getElementsByClassName('printBody')[0].innerHTML
      window.print()
      window.location.reload()
    }
    goback = () => {
      this.props.history.push('/main/deliverGoods/deliverList')
    }
    render () {
      const { sping, data } = this.state
      var currencyObj = {
        'TWD':"台币",
        'HKD':"港币",
        'KRW':"韩币",
        'RMB':"人民币",
        'USD':"美元",
        'JPY':"日元",
        'EUR':"欧元",
        'GBP':"英镑",
      }
      return (<div className="returnList">
        <Spin spinning={sping}>
          <div className="search" style={{width: '90%', marginLeft: '5%'}}>
            <div className="printBody">
              <h1 style={{fontSize: '28px', fontWeight: 'bold', textAlign: 'center'}}>{data.sname||""}销售清单（随货同行）</h1>
              <p style={{borderTop: '1px solid #e5e5e5', padding: '10px 5px', margin: 0}}>
                <span style={{display: 'inline-block', width: '35%'}}>收货单位：	{getCookie("business_name")}</span>
                <span>发货日期：{data.delivery_time}</span>
              </p>
              <p style={{borderTop: '1px solid #e5e5e5', padding: '10px 5px', margin: 0}}>
                <span style={{display: 'inline-block', width: '35%'}}>收货地址：{data.address}</span>
                <span>收货联系人：{data.receiver_user}</span>
              </p>
              <p style={{borderTop: '1px solid #e5e5e5', padding: '10px 5px', margin: 0}}>
                <span style={{display: 'inline-block', width: '35%'}}>客户订单号：{data.po_code}</span>
                <span>联系电话：{data.link_tel}</span>
              </p>
              <table style={{width: '100%'}}>
                <thead>
                  <tr style={{background: '#e5e5e5'}}>
                    <td style={{width: '7.6%', border: '1px solid', textAlign: 'center', padding: '5px 0'}}>商品名称</td>
                    <td style={{width: '7.6%', border: '1px solid', textAlign: 'center', padding: '5px 0'}}>医疗器械名称</td>
                    <td style={{width: '7.6%', border: '1px solid', textAlign: 'center', padding: '5px 0'}}>规格型号</td>
                    <td style={{width: '6.2%', border: '1px solid', textAlign: 'center', padding: '5px 0'}}>注册人/备案人</td>
                    <td style={{width: '7.6%', border: '1px solid', textAlign: 'center', padding: '5px 0'}}>生产企业（含委托）</td>
                    <td style={{width: '8.6%', border: '1px solid', textAlign: 'center', padding: '5px 0'}}>医疗器械生产许可证</td>
                    <td style={{width: '6.6%', border: '1px solid', textAlign: 'center', padding: '5px 0'}}>数量</td>
                    <td style={{width: '5.6%', border: '1px solid', textAlign: 'center', padding: '5px 0'}}>单位</td>
                    <td style={{width: '6.6%', border: '1px solid', textAlign: 'center', padding: '5px 0'}}>单价（{get(data,'details.0.base_money_type')}）</td>
                    <td style={{width: '7.6%', border: '1px solid', textAlign: 'center', padding: '5px 0'}}>金额</td>
                    <td style={{width: '7.6%', border: '1px solid', textAlign: 'center', padding: '5px 0'}}>医疗器械注册证</td>
                    <td style={{width: '6.6%', border: '1px solid', textAlign: 'center', padding: '5px 0'}}>生产批号</td>
                    <td style={{width: '6.6%', border: '1px solid', textAlign: 'center', padding: '5px 0'}}>失效日期</td>
                    <td style={{width: '7.6%', border: '1px solid', textAlign: 'center', padding: '5px 0'}}>存储条件</td>
                  </tr>
                </thead>
                <tbody style={{fontSize: '12px'}}>
                  {
                    data.details
                      ? data.details.map(item => {
                        return <tr>
                          <td style={{border: '1px solid', textAlign: 'center', padding: '5px 0'}}>{item.item_name || '-'}</td>
                          <td style={{border: '1px solid', textAlign: 'center', padding: '5px 0'}}>{item.medicine_name || '-'}</td>
                          <td style={{border: '1px solid', textAlign: 'center', padding: '5px 0'}}>{item.pro_model || '-'}</td>
                          <td style={{border: '1px solid', textAlign: 'center', padding: '5px 0'}}>{item.register_name || '-'}</td>
                          <td style={{border: '1px solid', textAlign: 'center', padding: '5px 0'}}>{item.producer || '-'}</td>
                          <td style={{border: '1px solid', textAlign: 'center', padding: '5px 0'}}>{item.producer_qual_code || '-'}</td>
                          <td style={{border: '1px solid', textAlign: 'center', padding: '5px 0'}}>{item.deliveryed_quantity || '-'}</td>
                          <td style={{border: '1px solid', textAlign: 'center', padding: '5px 0'}}>{item.unit || '-'}</td>
                          <td style={{border: '1px solid', textAlign: 'center', padding: '5px 0'}}>{item.po_price || '-'}</td>
                          <td style={{border: '1px solid', textAlign: 'center', padding: '5px 0'}}>{item.price || '-'}</td>
                          <td style={{border: '1px solid', textAlign: 'center', padding: '5px 0'}}>{item.register_qual_code || '-'}</td>
                          <td style={{border: '1px solid', textAlign: 'center', padding: '5px 0'}}>{item.lot || '-'}</td>
                          <td style={{border: '1px solid', textAlign: 'center', padding: '5px 0'}}>{item.expiry_date || '-'}</td>
                          <td style={{border: '1px solid', textAlign: 'center', padding: '5px 0'}}>{item.store_condition}</td>
                        </tr>
                      }) : ''
                  }
                </tbody>
                <tfoot>
                  <tr>
                    <td style={{border: '1px solid', textAlign: 'center', padding: '5px 0'}}>汇总：</td>
                    <td colSpan={13} style={{border: '1px solid', textAlign: 'right', padding: '5px 0'}}>
                      <span style={{marginRight: '20px'}}>总共数量合计：{data.details ? summation(data.details.map(item => { return item.deliveryed_quantity })) : 0}</span>
                      <span style={{marginRight: '20px'}}>总共金额合计：{data.details ? outputMoney(summation(data.details.map(item => { return item.price }))) : 0}</span>
                      <span style={{marginRight: '20px'}}>{currencyObj[get(data,'details.0.base_money_type')]}（大写）：{data.big_money}</span>
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>
            <p style={{textAlign: 'center', margin: '20px 0'}}>
              <Button type="primary" shape="round" onClick={this.print}>打印</Button>
              <Button shape="round" style={{marginLeft: '25px'}} onClick={this.goback}>返回</Button>
            </p>
          </div>
        </Spin>
      </div>)
    }
}
export default WithPrint



// WEBPACK FOOTER //
// ./src/pages/deliverGoods/withPrint.js